import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const handleMenuNavigate = (event, value) => {
  window.location.href = event.target.attributes['href'].value;
}

const AppBarComponent = ({ anchorEl, open, handleMenuClick, handleMenuClose }) => (
  <AppBar position="static" style={{ backgroundColor: 'white', boxShadow: 'none' }}>
    <Toolbar style={{ display: 'flex', justifyContent: 'space-between' }}>
      {/* <Typography color="red" variant="h4" style={{ fontWeight: 'bolder', textWrap: 'nowrap' }}>
        J.D. POWER
      </Typography> */}
      <img src='./jdp-logo.svg' alt="J.D. POWER" style={{ height: '30px' }} />
      <Tooltip title="Navigation">
        <IconButton 
          id="menu-button" 
          edge="end" 
          color="inherit" 
          onClick={handleMenuClick} 
          aria-controls={open ? 'menu-list' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <FontAwesomeIcon icon={faBars} color="rgb(207, 32, 47)" />
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-list"
        aria-labelledby="menu-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        slotProps={ { paper: { style: {  width: '100%', maxWidth: 'none' } } } }
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{ width: '100%', left: '16px' }}
      >
        <MenuItem onClick={handleMenuNavigate} href='https://www.jdpower.com/cars-for-sale'>Cars for Sale</MenuItem>
        <Divider />
        <MenuItem onClick={handleMenuNavigate} href='https://www.jdpower.com/cars'>Pricing & Values</MenuItem>
        <Divider />
        <MenuItem onClick={handleMenuNavigate} href='https://www.jdpower.com/electric-vehicles'>Research</MenuItem>
        <Divider />
        <MenuItem onClick={handleMenuNavigate} href='https://canada.jdpower.com/'>Business</MenuItem>
        <Divider />
        <MenuItem onClick={handleMenuNavigate} href='https://www.jdpower.com/cars-for-sale/my-saved-cars'>My Saved Cars</MenuItem>
        <Divider />
        <MenuItem component={Link} to="/">Cars</MenuItem>
        <Divider />
        <MenuItem component={Link} to="/experiment">Experiment</MenuItem>
      </Menu>
    </Toolbar>
  </AppBar>
);

export default AppBarComponent;